import { useState } from 'react'

export type SnackbarSeverity = 'success' | 'error' | 'info' | 'warning'

export interface UseSnackbarReturn {
  open: boolean
  message: string
  severity: SnackbarSeverity
  show: (message: string, severity?: SnackbarSeverity) => void
  close: () => void
}

/**
 * Hook para manejar notificaciones con Snackbar
 * Reduce boilerplate en componentes que necesitan mostrar mensajes
 */
export const useSnackbar = (): UseSnackbarReturn => {
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [severity, setSeverity] = useState<SnackbarSeverity>('success')

  const show = (msg: string, sev: SnackbarSeverity = 'success') => {
    setMessage(msg)
    setSeverity(sev)
    setOpen(true)
  }

  const close = () => setOpen(false)

  return { open, message, severity, show, close }
}
